import getSearchParams from '../../util/getSearchParams';

const getCampaignParams = () => {
  const searchParams = getSearchParams();
  const validParams = ['gcamid', 'gclid', 'msclkid', 'mscamid', 'wpset'];
  const campaignParams = new URLSearchParams();

  for (const [name, value] of searchParams) {
    if (validParams.includes(name)) {
      campaignParams.append(name, value);
    }
  }

  return campaignParams;
};

export default getCampaignParams;
